import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const PhotoIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 21" {...props}>
            <path
                d="M7.11813 6.43164H4.25267C3.87269 6.43164 3.50827 6.58154 3.23958 6.84836C2.97089 7.11518 2.81995 7.47707 2.81995 7.85441V15.6797C2.81995 16.057 2.97089 16.4189 3.23958 16.6857C3.50827 16.9526 3.87269 17.1025 4.25267 17.1025H17.1472C17.5272 17.1025 17.8916 16.9526 18.1603 16.6857C18.429 16.4189 18.5799 16.057 18.5799 15.6797V7.85441C18.5799 7.47707 18.429 7.11518 18.1603 6.84836C17.8916 6.58154 17.5272 6.43164 17.1472 6.43164H14.2818M7.11813 6.43164L8.55085 4.29747H12.849L14.2818 6.43164M7.11813 6.43164H14.2818"
                fill="none"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.7 14.6837C12.2826 14.6837 13.5655 13.4097 13.5655 11.8382C13.5655 10.2666 12.2826 8.99263 10.7 8.99263C9.1175 8.99263 7.83459 10.2666 7.83459 11.8382C7.83459 13.4097 9.1175 14.6837 10.7 14.6837Z"
                fill="none"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <ellipse cx="5.54213" cy="9.24873" rx="0.859637" ry="0.853667" fill="white" />
        </SvgIcon>
    );
};
